export default __webpack_public_path__ + "static/media/PARQUET.1df1935f.png";